import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerFacade } from '@ridango/components';

import { RidePlannerFacade } from '@ridango/components/lib/ride-planner/+state/ride-planner.facade';
import Env from '@ridango/core/env';
import { Observable } from 'rxjs';

@Component({
    templateUrl: './book-ride-parent-page.component.html',
    styleUrls: ['./book-ride-parent-page.component.scss']
})
export class BookRideParentPageComponent implements OnInit {
    steps = ['BOOK_RIDE_PLAN_RIDE', 'BOOK_RIDE_SPECIFY_RIDE', 'BOOK_RIDE_REVIEW_RIDE'];

    activeStep$ = this.ridePlanner.step$;
    profile$: Observable<any> = this.customerFacade.profile$;

    constructor(
        @Inject('ENV') public env: Env,
        private ridePlanner: RidePlannerFacade,
        private customerFacade: CustomerFacade,
        private router: Router,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.customerFacade.getCustomerProfile();

        if (this.env.ONDEMAND?.PAYMENT_ON_WEB) {
            this.steps.push('BOOK_RIDE_PAID');
        }
    }

    async redirectToProfile(): Promise<void> {
        await this.router.navigate([this.translate.currentLang, 'account', 'profile'], { state: { editMode: true } });
    }
}
